import React from "react";
import "./blogs.css";

const Arush = () => {
  return (
    <div className="blog">
      <div className="row blog-row">
        <div className="col-md-4">
          <div
            style={{
              height: "auto",
              width: "auto",
              overflow: "hidden",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "15px",
            }}
          >
            <img
              src="placement-postulates/dp/Arush-Kumar-Rai.jpg"
              style={{
                height: "100%",
                width: "100%",
                borderRadius: "15px",
                objectFit: "cover",
                objectPosition: "centre middle",
              }}
              alt="Arush"
            />
          </div>
        </div>
        <div className="col-md-8">
          <div className="blog-head">
            <h2>Arush Kumar Rai</h2>
            <small> Tata Projects Limited</small>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row blog-row">
          <div className="col-md-12">
            <h3>Introduction </h3>
            <p>
              Hi everyone, I'm Arush, a Y20 BT-CE student, currently placed at
              Tata Projects Limited (TPL).
              <br /> This blog captures my journey from uncertainty and
              indecision to securing a coveted offer at TPL. I hope it offers
              valuable insights for those on a similar path
            </p>
          </div>
        </div>
        <img
          class="blog-image-right"
          src="placement-postulates/blogs/Arush-Kumar-Rai/1.jpg"
          alt="Arush"
        />
        <div className="row blog-row">
          <div className="col-md-12">
            <h3>From Uncertainty to Commitment:</h3>
            <p>
              Unlike many of my peers, I didn't participate in the internship
              season. I wasn't keen on joining the corporate sector and wasn't
              initially interested in placements either. However, after the
              internship season, seeing all my friends and wingmates head off to
              exciting places like Bangalore, Pune, Hyderabad etc, I found
              myself pondering my future while sitting in my room: "main kya kar
              rha hu yahan? Kya karna chahiye mujhe? Thodi si jealousy bhi thi"
              but Within a week, my mindset shifted dramatically. I decided to
              give placements a shot, but I needed a solid resume and the right
              skills. This blog shares my journey from that turning point to
              securing a job offer at Tata Projects Limited.
            </p>
          </div>
        </div>

        <div className="row blog-row">
          <div className="col-md-12">
            <h3>The Consulting vs. Core Dilemma</h3>
            <p>
              While many of my friends were drawn to software, data analytics,
              and data science roles, I was torn between consulting and core
              civil engineering. I prepared resumes for consulting, core, APM,
              and data analyst roles but poured most of my effort into the core
              and consulting options. My strong communication and
              decision-making skills, combined with my academic performance in
              core subjects, made these two paths particularly appealing.
            </p>
          </div>
        </div>
        <br />
        <br />
        <br />
        <img
          class="blog-image-right"
          src="placement-postulates/blogs/Arush-Kumar-Rai/2.jpg"
          alt="Arush"
        />
        <div className="row blog-row">
          <div className="col-md-12">
            <h3>Opportunities for Civil Core in SPO Placement Drive</h3>
            <p>
              Initially, I was skeptical about the availability of civil core
              opportunities during the placement season, given the lack of
              options during the internship season. However, I was pleasantly
              surprised by the decent number of core companies that
              participated. There were several noteworthy companies:
            </p>
            <p>
              Petronet LNG: The exam was similar to the GATE, consisting of 100
              questions in 70 minutes, in a pen-and-paper MCQ format.
              <br /> Smartrack AI: Offered a role as a Digital Construction
              Engineer.
              <br /> HPCL: Open for CE and ME students only.
              <br /> Reliance: Open for CE, ME, and CHE students.
              <br /> BPCL: Another significant recruiter..
              <br /> ARTPARK: Offered a role of Engineer-Structure Design in the
              CE core. And many more Despite initial doubts, there were ample
              opportunities for civil core students during the placement season
            </p>
          </div>
        </div>
        <img
          class="blog-image-left"
          style={{ height: "300px", width: "20%" }}
          src="placement-postulates/blogs/Arush-Kumar-Rai/3.jpg"
          alt="Arush"
        />
        <div className="row blog-row">
          <div className="col-md-12">
            <h3>The Shortlisting Journey</h3>
            <p>
              Tata Projects Limited (TPL) shortlists candidates based on their
              resumes without requiring any tests. To get shortlisted, having a
              good CPI, preferably above 8, or a strong civil core resume with
              decent civil projects or internships can help. Adding good
              management and communication skills is also a plus. Mention civil
              related software such as Abaqus, AutoCAD, SAP2000, and civil
              related python libraries.
            </p>
            <p>
              TPL was my second interview, following Microsoft on Day 1.1.
              Although the Microsoft interview didn't go well, I walked out of
              the interview room feeling a bit upset. It was hard not to let the
              disappointment sink in, but my wingmates were there to lift my
              spirits. They reminded me that this was just the beginning and
              that the best was yet to come.
            </p>
          </div>
        </div>

        <div className="row blog-row">
          <div className="col-md-12">
            <h3>Interview Preparation: The Key </h3>
            <p>
              One of the best parts of my life at IITK was the numerous
              interview experiences I had. I always encourage juniors to take
              every opportunity to give interviews. It provides invaluable
              learning, boosts confidence, and highlights areas for improvement.
            </p>
            <p>
              In my wing, almost 50% of my wingmates had Pre-Placement Offers
              (PPOs). They were incredibly dedicated to helping the rest of us
              prepare for interviews. Their commitment was so intense that even
              if I was going to take a bath, they'd stop me to ask for my
              introduction! Not just the standard IITK introduction, but a
              detailed one covering my locality, academic achievements,
              professional experiences, startup exposure, and extracurricular
              activities.
            </p>
            <p>
              We had our resumes ready well before the deadline. My wingmates
              took on the responsibility of setting up interview deadlines with
              different panels. Some focused on resume-based questions, others
              specialized in HR questions, and a few handled technical queries.
              Two of my wingmates, being civil engineering students themselves,
              delved deeply into civil core topics.
            </p>
            <p>
              Thanks to this thorough preparation, I was more than ready for any
              interview. I had been bombarded with hundreds of questions from
              15+ different minds, covering all aspects of the interview
              process. This rigorous practice was instrumental in my success. T
            </p>
          </div>
        </div>
        <img
          class="blog-image-right"
          src="placement-postulates/dp/Arush-Kumar-Rai.jpg"
          alt="Arush"
        />
        <div className="row blog-row">
          <div className="col-md-12">
            <h3>The Interview Experience</h3>
            <p>
              On Day 2.1, Tata Projects Limited (TPL) had scheduled their
              interviews. The company was added to the interview list just six
              hours earlier. My friends and I quickly started researching the
              experiences of candidates from other colleges where TPL had
              already conducted interviews to gather insights. I woke up,
              dressed up smartly (it does matter), and headed to the designated
              interview space. Before my turn, I spoke with some friends who had
              already completed their interviews. They shared their experiences,
              which helped me feel more prepared. When it was my turn, I entered
              the room and met the two interviewers. They introduced themselves
              and started with the easiest question: "Tell us about yourself." I
              aimed to deliver my introduction naturally, as if I hadn't
              rehearsed it.
            </p>
            <p>
              Next, they asked if I had sought inputs from others who had
              already given the interview. I honestly shared what I had learned
              from my friends, and the interviewers appreciated it. The
              conversation then shifted to my professional experience, and they
              asked me to elaborate on my internship. Following that, they
              inquired about my favorite course in civil engineering. I
              mentioned Hydrology, but they quickly noted that many candidates
              had chosen the same. They asked me to discuss a different one
              instead. Anticipating this, I confidently spoke about Steel
              Structures. They asked several questions about Steel Structures,
              most of which were basic, though a couple were tricky. The
              interviewers didn't expect perfection but appreciated a systematic
              approach to problem-solving.
            </p>
            <p>
              Towards the end, they asked about my interest in civil core,
              considering my internship was in data analysis and management. I
              had prepared for this question and explained that while I had
              tried working with data, I realized it wasn't my passion. I
              expressed my strong interest in core civil engineering, which they
              seemed to appreciate. The interview concluded with standard HR
              questions like, "Why TPL and not another company?" and "What are
              your plans for the next 2-3 years?" They hinted that I might
              consider higher studies for UPSC preparation, but I assured them
              that I was committed to a long-term career at TPL. I emphasized
              that I saw myself in an administrative role at TPL in the next
              5-10 years, contributing valuable insights to help the company
              reach new heights. Finally, I asked a couple of thoughtful
              questions to the HR interviewer, which helped engage them further
              in the conversation
            </p>
          </div>
        </div>
        <img
          class="blog-image-right"
          src="placement-postulates/blogs/Arush-Kumar-Rai/4.jpg"
          alt="Arush"
        />
        <div className="row blog-row">
          <div className="col-md-12">
            <h3>Navigating the Placement Journey with Wingmates & Friends</h3>
            <p>
              The placement process can be challenging, but having a strong
              support system makes it much more manageable. One of the best ways
              to navigate this journey is by staying connected with your
              friends. Collaborate with them to review each other’s resumes,
              conduct mock interviews, and provide mutual encouragement. The
              process can often be stressful and demotivating, but having
              friends around helps ease the burden. During interviews, your
              friends can be incredibly helpful by taking care of logistical
              details like scheduling other interviews and submitting your
              resume for walk-ins. This support allows you to stay focused on
              the interview at hand without worrying about other tasks. Once you
              land a job, be sure to return the favor and assist your friends in
              their placement efforts.
            </p>
            <p>
              In addition to friends, the guidance and support from seniors,
              family members, and trusted acquaintances are invaluable. They can
              offer advice, share their experiences, and provide much-needed
              moral support. This network of support can help you stay motivated
              and resilient throughout the placement process. Remember, leaning
              on your support system and being there for others can make all the
              difference in successfully navigating the placement journey. Do
              help others for no reason, do favors, be kind to everyone (who
              deserves). Thank You.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Arush;
